import React from 'react';

export default function RabbitEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="12.8,15.25 5.84,12.37 7.76,7.73 14.72,10.61" fill="#F2A5C8" />
      <polygon points="33.4,12.37 26.45,15.25 24.52,10.61 31.48,7.73" fill="#F2A5C8" />
      <polygon points="33.29,25.41 28.68,24.88 28.68,19.86 33.29,20.39" fill="#F2A5C8" />
      <polygon points="9.71,24.9 2.75,22.02 6.6,12.74 13.55,15.63" fill="#F2A5C8" />
      <polygon points="2.75,22.02 2.0,21.64 5.84,12.37 6.6,12.74" fill="#E54B91" opacity="0.95" />
      <polygon points="38.0,22.02 31.04,24.9 27.2,15.63 34.16,12.74" fill="#F2A5C8" />
      <polygon points="31.04,24.9 38.0,22.02 37.25,21.64 30.29,24.53" fill="#E54B91" opacity="0.95" />
      <polygon points="31.04,24.9 30.29,24.53 26.45,15.25 27.2,15.63" fill="#E54B91" opacity="0.95" />
      <polygon points="34.06,27.73 30.51,24.18 34.06,20.62 37.61,24.18" fill="#F2A5C8" />
      <polygon points="35.58,24.11 32.27,23.42 32.27,18.4 35.58,19.09" fill="#E54B91" opacity="0.95" />
      <polygon points="30.8,24.74 10.71,24.74 10.71,22.23 30.8,22.23" fill="#F2A5C8" />
      <polygon points="10.71,24.74 30.8,24.74 29.29,23.99 9.2,23.99" fill="#E54B91" opacity="0.95" />
      <polygon points="10.71,24.74 9.2,23.99 9.2,21.48 10.71,22.23" fill="#E54B91" opacity="0.95" />
      <polygon points="33.31,32.27 30.8,32.27 30.8,22.23 33.31,22.23" fill="#F2A5C8" />
      <polygon points="30.8,32.27 33.31,32.27 31.8,31.52 29.29,31.52" fill="#E54B91" opacity="0.95" />
      <polygon points="30.8,32.27 29.29,31.52 29.29,21.48 30.8,22.23" fill="#E54B91" opacity="0.95" />
      <polygon points="10.71,32.27 8.2,32.27 8.2,22.23 10.71,22.23" fill="#F2A5C8" />
      <polygon points="8.2,32.27 10.71,32.27 9.2,31.52 6.69,31.52" fill="#E54B91" opacity="0.95" />
      <polygon points="8.2,32.27 6.69,31.52 6.69,21.48 8.2,22.23" fill="#E54B91" opacity="0.95" />
    </svg>
  );
}
